import './styles/PermissionGeneral.scss';

import { Autocomplete, FormControl, FormControlLabel, Grid, TextField } from '@mui/material';

import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export function PermissionGeneral() {
  const { t } = useTranslation();
  const { setFieldValue, setFieldTouched, values, errors, touched } = useFormikContext<{
    service: string;
    feature: string;
    scope: 'DELETE' | 'READ' | 'WRITE';
  }>();

  const scopeOptions = [{ label: 'DELETE' }, { label: 'READ' }, { label: 'WRITE' }];

  return (
    <Grid container spacing={2} justifyContent="center">
      <Grid item xs={12}>
        <FormControl className="permission-modal__input" required>
          <Field
            as={TextField}
            name="service"
            fullWidth
            label={t(translations.pages.permissions.model.service())}
            error={touched.service && errors.service}
            helperText={touched.service && errors.service}
            required
            inputProps={{ style: { textTransform: 'uppercase' } }}
            size="small"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl className="permission-modal__input" required>
          <Field
            as={TextField}
            name="function"
            fullWidth
            label={t(translations.pages.permissions.model.feature())}
            error={touched.feature && errors.feature}
            helperText={touched.feature && errors.feature}
            required
            inputProps={{ style: { textTransform: 'uppercase' } }}
            size="small"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl required fullWidth className="permission-modal__input">
          <FormControlLabel
            control={
              <Autocomplete
                options={scopeOptions}
                value={values.scope && scopeOptions.find(option => option.label === values.scope)}
                autoHighlight
                fullWidth
                getOptionLabel={option => option.label}
                onChange={async (event, value, reason) => {
                  setFieldValue('scope', value?.label, true);
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    error={touched.scope && !!errors.scope}
                    helperText={touched.scope && <>{errors.scope}</>}
                    fullWidth
                    required
                    onBlur={() => {
                      if (!touched.scope) {
                        setFieldTouched('scope', true);
                      }
                    }}
                    label={t(translations.pages.permissions.model.scope())}
                    inputProps={{
                      ...params.inputProps,
                      style: { padding: '6 0 7' },
                      autoComplete: 'new-password'
                    }}
                    size="small"
                  />
                )}
              />
            }
            label={''}
            style={{ width: '100%' }}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
}
